import {AbstractControl} from "@angular/forms";

export const getFirstInvalidControl = (controls: {
    [key: string]: AbstractControl;
}): string | null => {
    for (const name in controls) {
        if (controls[name].invalid && controls[name].enabled) {
            const element = document.querySelector(`[formControlName="${name}"]`) as HTMLElement;
            if (element && element.offsetParent !== null) {
                return name;
            }
            return name;
        }
    }
    return null;
}

export const focusFirstInvalidField = (controls: {
    [key: string]: AbstractControl;
}): void => {
    const firstInvalidControl = getFirstInvalidControl(controls);
    if (firstInvalidControl) {
        const element = document.querySelector(`[formControlName="${firstInvalidControl}"]`);
        if (element instanceof HTMLElement) {
            element.focus();
            element.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
    }
}
